import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AuthGuardService } from '../authentication/auth-guard.service';
import { PaginatorModule } from 'primeng/primeng';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FuseWidgetModule } from '@fuse/components';
import { MyTeamComponent } from './my-team.component';
import { MatAutocompleteModule, MatDatepickerModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule, MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { TreeModule } from 'primeng/tree';
import { MatTableModule, MatSelectModule } from '@angular/material';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { TeamSheetComponent } from './team-sheet/team-sheet.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'app/shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';

const routes = [
    { path: '', redirectTo: 'my-team', pathMatch: 'full', canActivate: [AuthGuardService] },
    { path: 'my-team', component: MyTeamComponent, canActivate: [AuthGuardService] },
    { path: 'team-sheet', component: TeamSheetComponent, canActivate: [AuthGuardService] },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        PaginatorModule,
        NgxSpinnerModule,
        FuseWidgetModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatTabsModule,
        MatTooltipModule,
        MatRippleModule,
        FuseSharedModule,
        OrganizationChartModule,
        TreeModule,
        MatTableModule,
        MatOptionModule,
        MatSelectModule,
        RoundProgressModule,
        MatDatepickerModule,
        MatPaginatorModule,
        BrowserAnimationsModule,
        MatCheckboxModule,
        CardModule,
        TableModule,
        SharedModule,
        MatAutocompleteModule,
    ],
    declarations: [MyTeamComponent, TeamSheetComponent]
})
export class MyTeamModule { }
